// extracted by mini-css-extract-plugin
export var editButton = "_o4-0";